// src/pages/MainsPage.jsx
import React, { useState, useEffect, useCallback } from "react";
import DailyMainsSecure from "../components/jnanadeepam/DailyMainsSecure";
import { jnanaDeepamMains } from "../data/jnanaDeepamData";
import { publicAPI } from "../services/publicApi";

export default function MainsPage() {
  const [publishedMains, setPublishedMains] = useState([]);

  // Fetch any newly published Mains initiatives from MongoDB backend
  const fetchMains = useCallback(async () => {
    try {
      const res = await publicAPI.getMainsInitiatives();
      if (res?.success && Array.isArray(res.data)) {
        setPublishedMains(res.data);
      }
    } catch (e) {
      console.warn("Could not fetch published Mains initiatives:", e.message);
    }
  }, []);

  useEffect(() => {
    fetchMains();
    // Poll every 15 seconds to ensure live admin sync
    const interval = setInterval(fetchMains, 15000);
    return () => clearInterval(interval);
  }, [fetchMains]);

  return (
    <div className="w-full bg-[#f8fafc] min-h-screen py-6 sm:py-8">
      <DailyMainsSecure
        questions={jnanaDeepamMains}
        backendMains={publishedMains}
      />
    </div>
  );
}
